export const getSvgFilePathMixin = {
  methods: {
    getSvgFilePath: function(name, directory = '/icons/') {
      return process.env.ASSET_PATH + 'svg' + directory + name + '.svg'
    }
  }
}